'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var height = '92px';

exports.default = _react2.default.createClass({
  displayName: 'CompanyLogo',

  propTypes: {
    compact: _react.PropTypes.bool,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    hideLogo: _react.PropTypes.bool,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired
  },

  hasLogo: function hasLogo() {
    var _props = this.props,
        logoUrl = _props.branding.logoUrl,
        isFetchingPublicGlobalBranding = _props.isFetchingPublicGlobalBranding;

    return Boolean(logoUrl) && !isFetchingPublicGlobalBranding;
  },
  render: function render() {
    var _props2 = this.props,
        compact = _props2.compact,
        logoUrl = _props2.branding.logoUrl,
        hideLogo = _props2.hideLogo;


    var hasLogo = this.hasLogo();

    if (hideLogo || !hasLogo) {
      return null;
    }
    var classes = (0, _reactUtils.classNames)('p-top-4', { 'm-bottom-4': compact });

    return _react2.default.createElement(
      'div',
      { className: classes, style: { height: height, background: _colors.GYPSUM } },
      _react2.default.createElement(_UIImage2.default, { className: 'branding-company-logo m-x-auto', src: logoUrl })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/decorative/CompanyLogo.js
// module id = 297
// module chunks = 0